import { createAction } from "redux-act";
const uiOnlyMeta = () => ({ forward: false, scope: "local" });
/**
 * action to choose which item in a group to display (all other items in the
 * group will be hidden). the itemId can be undefined to hide them all.
 */
export const displayGroup = createAction("DISPLAY_GROUP", (groupId, itemId) => ({ groupId, itemId }));
export const setDialogVisible = createAction("SET_DIALOG_VISIBLE", (dialogId) => ({ dialogId }));
export const setSettingsPage = createAction("SET_SETTINGS_PAGE", (pageId) => ({ pageId }));
export const setOpenMainPage = createAction("SET_OPEN_MAINPAGE", (page, secondary) => ({ page, secondary }));
export const startActivity = createAction("START_ACTIVITY", (group, activityId) => ({ group, activityId }), uiOnlyMeta);
export const stopActivity = createAction("STOP_ACTIVITY", (group, activityId) => ({ group, activityId }), uiOnlyMeta);
export const setProgress = createAction("SET_PROGRESS", (group, progressId, text, percent) => ({
    group,
    progressId,
    text,
    percent,
}));
export const setToolRunning = createAction("SET_TOOL_RUNNING", (exePath, started, exclusive) => ({
    exePath,
    started,
    exclusive,
}));
export const setToolPid = createAction("SET_TOOL_PID", (exePath, pid, exclusive) => ({
    exePath,
    pid,
    exclusive,
}));
export const setToolStopped = createAction("SET_TOOL_STOPPED", (exePath) => ({ exePath }));
export const setExtensionLoadFailures = createAction("SET_EXT_LOAD_FAILURES", (failures) => failures);
export const setUIBlocker = createAction("SET_UI_BLOCKER", (id, icon, description, mayCancel) => ({
    id,
    icon,
    description,
    mayCancel,
}));
export const clearUIBlocker = createAction("CLEAR_UI_BLOCKER", (id) => id);
export const setNetworkConnected = createAction("SET_NETWORK_CONNECTED", (connected) => connected);
export const setCommandLine = createAction("SET_COMMAND_LINE", (args) => args);
export const setDownloadGameFilter = createAction("SET_DOWNLOAD_GAME_FILTER", (gameId) => gameId);
